import { render } from "./RedirectingView.vue?vue&type=template&id=67588a5a&scoped=true&ts=true"
import script from "./RedirectingView.vue?vue&type=script&lang=ts"
export * from "./RedirectingView.vue?vue&type=script&lang=ts"

import "./RedirectingView.vue?vue&type=style&index=0&id=67588a5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67588a5a"]])

export default __exports__